module.exports = __webpack_public_path__ + "static/media/hundred_bp_dna_ladder_marker.713aacfe.svg";